import React from 'react';
import ProtectedRoute from '../../Components/ProtectedRoute';
import { PermissionWrapper } from '../../Funcoes/PermissionWrapper';
import { PropertyViewController, PropertyViewControllerDelegate } from '../../Screen/Property/PropertyViewController';
import { PropertyViewModel } from '../../Screen/Property/PropertyViewModel';
import { NavOptions, TableGenericViewController, TableGenericViewControllerDelegate } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TableGenericFilter } from '../TableGeneric/TableGenericInteractor';

export class PropertyCoordinator implements IndexCoordinatorDelegate, PropertyViewControllerDelegate, TableGenericViewControllerDelegate {

    private copyProp: boolean
    private typeProp: string
    constructor() {
        this.copyProp = false
        this.typeProp = ""
    }

    getRoute(): JSX.Element[] {
        return [
            this.routeForm(),
            this.routeTable()
        ]
    }

    private routeForm(): JSX.Element {
        var viewModel = new PropertyViewModel()
        return (<ProtectedRoute requiredPermissions={['geppropriedade.*']} path="/:base/ponto/:idPoint/propriedade/tipo/:type/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            var idPoint = props.match.params.idPoint
            var typePoint = props.match.params.type
            return (<PropertyViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idPoint={idPoint}
                copyProp={this.copyProp}
                typeProp={typePoint}
            />)
        }} />)
    }

    private routeTable(): JSX.Element {
        const viewModel = new TableGenericViewModel("geppropriedade");

        return (
            <ProtectedRoute
                requiredPermissions={['geppropriedade.*']}
                path="/:base/ponto/:idPoint/propriedade/tipo/:type"
                exact
                component={(props: any) => {
                    const typePoint = props.match.params.type;

                    this.typeProp = typePoint
                    const idPoint = props.match.params.idPoint;
                    const requiredPerms = [
                        "acao.hist_prop.urbano.proc_adm.ver",
                        "acao.hist_prop.urbano.proc_adm.adicionar",
                        "acao.hist_prop.urbano.proc_adm.editar",
                        "acao.hist_prop.urbano.proc_adm.excluir",

                        "acao.hist_prop.rural.proc_adm.ver",
                        "acao.hist_prop.rural.proc_adm.adicionar",
                        "acao.hist_prop.rural.proc_adm.editar",
                        "acao.hist_prop.rural.proc_adm.excluir",

                        "acao.hist_prop.cemiterio.proc_adm.ver",
                        "acao.hist_prop.cemiterio.proc_adm.adicionar",
                        "acao.hist_prop.cemiterio.proc_adm.editar",
                        "acao.hist_prop.cemiterio.proc_adm.excluir",

                        "acao.hist_prop.diverso.proc_adm.ver",
                        "acao.hist_prop.diverso.proc_adm.adicionar",
                        "acao.hist_prop.diverso.proc_adm.editar",
                        "acao.hist_prop.diverso.proc_adm.excluir",


                        "acao.hist_prop.urbano.visita.ver",
                        "acao.hist_prop.rural.visita.ver",
                        "acao.hist_prop.cemiterio.visita.ver",
                        "acao.hist_prop.diverso.visita.ver",
                    ]


                    return (
                        <PermissionWrapper requiredPermissions={requiredPerms} delegate={this}>{(permissions, delegate) => {
                            const arrayOptions: NavOptions[] = [];

                            let propertyProcessAdmPerm = false
                            let visitPropertyPerm = false

                            //exibir opção de Processo Admin
                            if (permissions["acao.hist_prop.urbano.proc_adm.ver"] == true && typePoint === 'U' ||
                                permissions["acao.hist_prop.rural.proc_adm.ver"] == true && typePoint === 'R' ||
                                permissions["acao.hist_prop.cemiterio.proc_adm.ver"] == true && typePoint === 'C' ||
                                permissions["acao.hist_prop.diverso.proc_adm.ver"] == true && typePoint === 'D') {
                                propertyProcessAdmPerm = true
                            }

                            //exibir opção de Visita
                            if (permissions["acao.hist_prop.urbano.visita.ver"] == true && typePoint === 'U' ||
                                permissions["acao.hist_prop.rural.visita.ver"] == true && typePoint === 'R' ||
                                permissions["acao.hist_prop.cemiterio.visita.ver"] == true && typePoint === 'C' ||
                                permissions["acao.hist_prop.diverso.visita.ver"] == true && typePoint === 'D') {
                                visitPropertyPerm = true
                            }

                            arrayOptions.push({
                                title: "Arquivos Digitais (Documentos)",
                                action: (nav, item) => delegate.tapDocuments(nav, item),
                                isSelection: true
                            });

                            arrayOptions.push({
                                title: "Duplicar histórico",
                                action: (nav, item) => delegate.tapCopyProp(nav, item),
                                isSelection: true
                            });

                            if (typePoint !== 'D') {
                                arrayOptions.push({
                                    title: "Edificações",
                                    action: (nav, item) => delegate.tapBuildings(nav, item),
                                    isSelection: true
                                });
                            }

                            if (propertyProcessAdmPerm) {
                                arrayOptions.push({
                                    title: "Processo Administrativo",
                                    action: (nav, item) => delegate.tapAdminProcess(nav, item),
                                    isSelection: true
                                });
                            }
                            if (visitPropertyPerm) {
                                arrayOptions.push({
                                    title: "Visitas",
                                    action: (nav, item) => delegate.tapVisit(nav, item),
                                    isSelection: true
                                });
                            }

                            arrayOptions.push({
                                title: "Cadastros Agropecuário",
                                action: (nav, item) => delegate.tapAgriculturalRegistration(nav, item),
                                isSelection: true
                            });

                            return (
                                <TableGenericViewController
                                    navigation={props}
                                    viewModel={viewModel}
                                    delegate={delegate}
                                    filter={[new TableGenericFilter('Ponto', idPoint)]}
                                    options={arrayOptions}
                                    title="Histórico da Propriedade"
                                />
                            );
                        }}
                        </PermissionWrapper>
                    );
                }}
            />
        );
    }


    add(navigation: any, viewModel: TableGenericViewModel): void {
        var filter = viewModel.getFilter()
        this.copyProp = false

        if (filter) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/ponto/${filter[0].getValue()}/propriedade/tipo/${this.typeProp}/cad/0`);
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        var filter = viewModel.getFilter()
        this.copyProp = false

        if (filter) {
            var database = localStorage.getItem('database')
            navigation.history.push(`/${database}/ponto/${filter[0].getValue()}/propriedade/tipo/${this.typeProp}/cad/${idSelection}`);
        }
    }

    tapCopyProp(navigation: any, item: any): void {
        this.copyProp = true
        navigation.history.push(`${this.typeProp}/cad/${item}`);
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    tapDocuments(navigation: any, item: any): void {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/propriedade/${item}/arquivos`);
    }

    tapBuildings(navigation: any, item: any): void {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/propriedade/tipo/${this.typeProp}/${item}/edificacoes`);
    }

    tapVisit(navigation: any, item: any): void {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/propriedade/tipo/${this.typeProp}/${item}/visita`);
    }

    tapAgriculturalRegistration(navigation: any, item: any): void {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/propriedade/${item}/agricultural-registration`);
    }

    tapAdminProcess(navigation: any, item: any): void {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/propriedade/${item}/tipo/${this.typeProp}/processo-administrativo`);
    }
}